import React, { Component } from 'react';
import { getinsightcontentDetailPage } from '../../API/FetchCall';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class InnerArticles extends Component {

  constructor(props) {
    super(props);
    this.state = {
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location").toLowerCase() : 'bengaluru',
      contentList: [],
      currentDetail: '',
      currentTitle: '',
      showPop: false,
      auth: false
    }
    this.topics();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  topics = async () => {
    try {
      let req = JSON.stringify({
        role: 4,
        category: 1,
        location: this.state.current_location
      })
      const response = await getinsightcontentDetailPage(req);
      if (response.status === 1) {
        this.setState({ contentList: response.list });
      } else {
        this.setState({ contentList: [] });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    };
    return (
      <React.Fragment>
        <div class="container">
          <div class="row">

            <div class="home-art p-4 col-lg-12 col-xs-12 col-sm-12">
              {this.state.contentList.length > 0 && (
                <Slider ref={c => (this.slider = c)} {...settings} >
                  {
                    this.state.contentList.map((content, inx) => {
                      return (
                        <div class="blogbox">
                          <a href={'/articles-blogs/' + content.slug_term} target='_blank' className="" >
                            <div class="blogTitle">
                              {content.title}
                            </div>
                          </a>
                          <div class="blogDet">
                            { /* <div class="blogdetImgpart newhome-blogimagepart"><img src={content.banner_image} class="blog-author-img" alt="Author Profile Image" /></div> */ }
                            <div class="blogdetpart">
                              <div class="blogdescription">
                                {content.desc.length > 50 ?
                                  <React.Fragment>
                                    <span>{content.desc.slice(0, 50)} </span>... &nbsp;
                                    <a href={'/articles-blogs/' + content.slug_term} target='_blank' className="" >
                                      <span className="moretolink">More</span>
                                    </a>
                                  </React.Fragment>
                                  : content.desc}

                              </div>
                              <div class="blogauthor">{content.author_name}</div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </Slider>
              )}
            </div>
          </div>
        </div>
      </React.Fragment >
    )
  }
}


export default InnerArticles;